<template>
	<tr :class="`c-list-row ${cssClasses}`" :id="row.id">
		<template v-for="item in row.items">
			<list-item ref="listItem" v-bind="item"></list-item>
		</template>
		<slot name="last-item"></slot>
	</tr>
</template>

<script>
import ListItem from '@/components/vue-components/list-item/ListItem.vue';
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';

export default {
    name: 'ListRow',
	components: { ListItem, VueInput },
    props: {
		row: {
			type: Object,
			default: () => {}
		},
		cssClasses: {
			type: String,
			default: 't-background-white'
		}
	}
}
</script>